interface LinkObject {
  __typename?: string;
  createdAt?: string;
  updatedAt?: string;
  order?: number;
  post?: unknown;
  source?: string;
  status?: string;
  [key: string]: unknown;
}

type ModifiedLinkObject = Omit<
  LinkObject,
  | '__typename'
  | 'createdAt'
  | 'updatedAt'
  | 'order'
  | 'post'
  | 'source'
  | 'status'
>;

const modifyLinkObject = (link: LinkObject): ModifiedLinkObject => {
  const {
    __typename,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    order: _order,
    post: _post,
    source: _source,
    status: _status,
    ...other
  } = link;
  return other;
};

export default modifyLinkObject;
